export default __webpack_public_path__ + "static/media/750x600_cam.fcb5e9df.jpg";